import { RouteItemType, type RouteItemTypeRecord, type RouteRecordForSolution } from '@navio/nsdk';
import { Collapsible, CollapsibleContent } from 'noddi-ui-web/src/base';
import type { ReactNode } from 'react';
import { useState } from 'react';
import { RouteAccordionHeader } from './RouteAccordionHeader';
import { TransferRouteSwimLane } from './TransferRouteSwimLane';

const PROGRESSION_TYPES = new Set<string>([RouteItemType.BOOKING, RouteItemType.RELOAD, RouteItemType.TRANSFER_STOP]);

type Props = {
  route: RouteRecordForSolution;
  renderBookingLink?: (bookingId: number, name: string) => ReactNode;
  renderUserGroupLink?: (userGroupId: number, name: string) => ReactNode;
  defaultExpanded?: boolean;
  solutionErrors?: ReactNode;
  onWorkerClick?: () => void;
  isRouteStatusPage?: boolean;
  /** A planned-not-saved route: its depots do not exist on the server, so they open nothing. */
  isPreview?: boolean;
  /** Opens this instead of a stop's own sheet: a preview's stops have no server record to load. */
  onStopClick?: (routeItem: RouteItemTypeRecord) => void;
};

export const TransferRoutesOverview = ({
  route,
  renderBookingLink,
  renderUserGroupLink,
  defaultExpanded = true,
  solutionErrors,
  onWorkerClick,
  isRouteStatusPage,
  isPreview = false,
  onStopClick
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <Collapsible
      open={isExpanded}
      className='flex w-full min-w-0 flex-col overflow-hidden rounded-xl border bg-card shadow-xs'
    >
      <RouteAccordionHeader
        route={route}
        isExpanded={isExpanded}
        onToggleExpand={() => setIsExpanded((prev) => !prev)}
        solutionErrors={solutionErrors}
        onWorkerClick={onWorkerClick}
        isRouteStatusPage={isRouteStatusPage}
        numberOfStops={(route.routeItems ?? []).filter((item) => PROGRESSION_TYPES.has(item.type)).length}
      />
      <CollapsibleContent className='min-w-0 overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down'>
        <div className='min-w-0 overflow-hidden border-t'>
          <TransferRouteSwimLane
            route={route}
            isInsideAccordion
            renderBookingLink={renderBookingLink}
            renderUserGroupLink={renderUserGroupLink}
            isRouteStatusPage={isRouteStatusPage}
            isPreview={isPreview}
            onStopClick={onStopClick}
          />
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};
